(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sky-cold-cup-scenes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cold-cup-scenes')) {
    customElements.define('cold-cup-scenes', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enhanced) return;
        this.tabs = Array.from(this.querySelectorAll('[data-scene-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-scene-panel]'));
        if (!this.tabs.length) return;
        const list = this.querySelector('.cold-scenes__tabs');
        list.hidden = false;
        list.setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); this.select(next); this.tabs[next].focus(); }
          });
        });
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index !== -1) this.select(index);
        });
        this.dataset.enhanced = 'true';
        this.select(0);
        this.timer = window.setInterval(() => {
          if (!this.paused) this.select((this.index + 1) % this.tabs.length);
        }, 5000);
        this.addEventListener('mouseenter', () => { this.paused = true; });
        this.addEventListener('mouseleave', () => { this.paused = false; });
        this.addEventListener('focusin', () => { this.paused = true; });
        this.addEventListener('focusout', () => { this.paused = false; });
      }
      disconnectedCallback() { if (this.timer) window.clearInterval(this.timer); }
      select(index) {
        this.index = index;
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sky-pacdora-super-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-sky-super-banner]';

    const escapeAttribute = (value) =>
      String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('"', '&quot;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;');

    const frameDocument = (config, model) => {
      const sdkUrl = `https://api.pacdora.com/sdk/Pacdora.js?app_id=${encodeURIComponent(config.appId)}`;
      const childConfig = JSON.stringify({
        sectionId: config.sectionId,
        blockId: model.blockId,
        appId: config.appId,
        appKey: config.appKey,
        templateId: model.templateId,
        themeColor: config.themeColor,
        initialAnimation: config.initialAnimation,
        autoRotate: model.autoRotate ?? config.autoRotate,
        rotationSpeed: config.rotationSpeed,
        shadow: config.shadow,
        productUrl: model.productUrl,
        lockXAxis: model.lockXAxis,
        initialRotation: model.initialRotation
      });
      const shadow = config.shadow || {};
      const shadowFilter = shadow.enabled
        ? `drop-shadow(${Number(shadow.offsetX) || 0}px ${Number(shadow.offsetY) || 0}px ${Number(shadow.blur) || 0}px rgba(20,31,54,${Number(shadow.opacity) || 0}))`
        : 'none';

      return `<!doctype html>
        <html lang="en">
          <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width,initial-scale=1">
            <style>
              html,body,#pacdora-viewer{width:100%;height:100%;margin:0;overflow:hidden;background:transparent}
              #pacdora-viewer canvas{
                background:transparent!important;
                /*
                 * Pacdora's public SDK does not expose scene light or cast-shadow
                 * controls. This shadow follows the transparent model silhouette,
                 * so its shape changes with the live 3D rotation instead of
                 * remaining a fixed ellipse. The offset represents a frontal
                 * key light approximately 30 degrees to camera-left.
                 */
                filter: ${shadowFilter};
              }
              body{touch-action:none}
              #pacdora-viewer{cursor:grab}
              #pacdora-viewer:active{cursor:grabbing}
              #pacdora-editor-trigger{position:fixed;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none}
            </style>
          </head>
          <body>
            <div
              id="pacdora-viewer"
              data-pacdora-ui="3d"
              data-pacdora-id="d3"
              data-init-rotation="${config.initialAnimation ? 'true' : 'false'}"
            ></div>
            <button
              id="pacdora-editor-trigger"
              type="button"
              data-pacdora-ui="advanced-design"
              data-pacdora-id="super-banner-editor"
              data-app-key="${escapeAttribute(config.appKey)}"
              data-save-screenshot="true"
              data-screenshot-width="1200"
            >Edit</button>
            <script src="${escapeAttribute(sdkUrl)}"></scr` + `ipt>
            <script>
              (() => {
                const config = ${childConfig};
                const viewerId = 'd3';
                const viewer = document.getElementById('pacdora-viewer');
                const editorTrigger = document.getElementById('pacdora-editor-trigger');
                const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                let frameId = 0;
                let hovering = false;
                let dragging = false;
                let pointerStart = null;
                let pointerMoved = false;
                let clickStart = null;
                let restoringXAxis = false;
                let initialPoseReady = false;
                let hoverRotationArmed = false;
                let xAxisRestoreTimers = [];

                const notify = (type, detail) => {
                  window.parent.postMessage({
                    source: 'sky-pacdora-super-banner',
                    sectionId: config.sectionId,
                    blockId: config.blockId,
                    type,
                    detail
                  }, '*');
                };

                const stopRotation = () => {
                  if (frameId) window.cancelAnimationFrame(frameId);
                  frameId = 0;
                };

                const rotate = () => {
                  if (
                    !hovering ||
                    dragging ||
                    !initialPoseReady ||
                    !hoverRotationArmed ||
                    reduceMotion ||
                    !config.autoRotate
                  ) {
                    frameId = 0;
                    return;
                  }

                  if (window.Pacdora && typeof window.Pacdora.rotate === 'function') {
                    window.Pacdora.rotate(viewerId, { y: Number(config.rotationSpeed) * 0.04 });
                  }
                  frameId = window.requestAnimationFrame(rotate);
                };

                const startRotation = () => {
                  if (
                    frameId ||
                    !hovering ||
                    dragging ||
                    !initialPoseReady ||
                    !hoverRotationArmed ||
                    reduceMotion ||
                    !config.autoRotate
                  ) return;
                  frameId = window.requestAnimationFrame(rotate);
                };

                const setTransparentBackground = () => {
                  if (window.Pacdora && typeof window.Pacdora.set3DBackground === 'function') {
                    window.Pacdora.set3DBackground(viewerId, 'transparent');
                  }
                };

                const setNativeDragRotation = async (enabled) => {
                  if (!window.Pacdora) return;
                  /*
                   * Pacdora's API reference names this method
                   * enable3DRotate(), while its official example uses
                   * enable3DRotation(). Support both documented spellings
                   * and explicitly keep native pointer rotation enabled.
                   */
                  const method =
                    typeof window.Pacdora.enable3DRotate === 'function'
                      ? window.Pacdora.enable3DRotate
                      : typeof window.Pacdora.enable3DRotation === 'function'
                        ? window.Pacdora.enable3DRotation
                        : null;
                  if (method) await method.call(window.Pacdora, viewerId, Boolean(enabled));
                };

                const enableNativeDragRotation = () => setNativeDragRotation(true);

                const setInitialRotation = () => {
                  if (window.Pacdora && typeof window.Pacdora.rotateTo === 'function') {
                    return Promise.resolve(
                      window.Pacdora.rotateTo(viewerId, {
                        x: Number(config.initialRotation && config.initialRotation.x) || 0,
                        y: Number(config.initialRotation && config.initialRotation.y) || 0,
                        z: Number(config.initialRotation && config.initialRotation.z) || 0
                      })
                    ).catch(() => {});
                  }
                  return Promise.resolve();
                };

                const readRotation = () =>
                  Promise.resolve(window.Pacdora.get3DRotation(viewerId)).then((rotation) => ({
                    x: normalizeAngle(rotationValue(rotation, 'x', 0)),
                    y: normalizeAngle(rotationValue(rotation, 'y', 1)),
                    z: normalizeAngle(rotationValue(rotation, 'z', 2))
                  }));

                const applyInitialPose = async () => {
                  initialPoseReady = false;
                  hoverRotationArmed = false;
                  stopRotation();
                  await setInitialRotation();
                  initialPoseReady = true;
                  notify('rotation:applied');
                };

                const toggleAction = (event) => {
                  notify('action:toggle', {
                    x: event && event.clientX,
                    y: event && event.clientY
                  });
                };

                const rotationValue = (rotation, axis, index) => {
                  const value = Number(
                    rotation && (
                      rotation[axis] ??
                      rotation['rotate' + axis.toUpperCase()] ??
                      rotation[index]
                    )
                  );
                  return Number.isFinite(value) ? value : 0;
                };

                const normalizeAngle = (value) => {
                  const normalized = ((Number(value) % 360) + 360) % 360;
                  return Math.abs(normalized) < 0.005 ? 0 : Number(normalized.toFixed(1));
                };

                const shortestAngleDelta = (target, current) => {
                  const normalizedTarget = normalizeAngle(target);
                  const normalizedCurrent = normalizeAngle(current);
                  return ((normalizedTarget - normalizedCurrent + 540) % 360) - 180;
                };

                const clearXAxisRestoreTimers = () => {
                  xAxisRestoreTimers.forEach((timer) => window.cancelAnimationFrame(timer));
                  xAxisRestoreTimers = [];
                };

                const restoreInitialUprightPose = () => {
                  if (
                    !config.lockXAxis ||
                    restoringXAxis ||
                    !window.Pacdora ||
                    typeof window.Pacdora.get3DRotation !== 'function' ||
                    typeof window.Pacdora.rotateTo !== 'function'
                  ) return Promise.resolve();

                  restoringXAxis = true;
                  /*
                   * Pause Pacdora's native rotation controller only for this
                   * one-shot correction. This prevents its final inertia
                   * update from overwriting the restored X/Z pose. Native
                   * dragging is enabled again immediately afterwards.
                   */
                  return setNativeDragRotation(false)
                    .then(() => readRotation())
                    .then((rotation) => {
                      if (!rotation) return;
                      /*
                       * Around an Euler pole Pacdora reports the same visual
                       * pose as Z≈180° with Y shifted by 180°. Keeping that Z
                       * value caused the upside-down state. Convert its yaw
                       * back to the upright representation, then restore the
                       * configured X without resetting the user's yaw. Always
                       * force Z to zero so the recovered pose cannot inherit a
                       * tilted or inverted Z value from either the model
                       * configuration or Pacdora's Euler representation.
                       */
                      const inverted = rotation.z > 90 && rotation.z < 270;
                      const uprightY = normalizeAngle(rotation.y + (inverted ? 180 : 0));
                      return window.Pacdora.rotateTo(viewerId, {
                        x: normalizeAngle(config.initialRotation && config.initialRotation.x),
                        y: uprightY,
                        z: 0
                      });
                    })
                    .catch(() => {})
                    .finally(async () => {
                      await setNativeDragRotation(true).catch(() => {});
                      restoringXAxis = false;
                    });
                };

                const scheduleXAxisRestore = async () => {
                  clearXAxisRestoreTimers();
                  if (dragging) return;
                  /*
                   * Waiting for several stable samples can prevent correction
                   * forever while Pacdora inertia keeps changing the pose.
                   * The restore function disables the native controller first,
                   * then reads and applies the single upright target.
                   */
                  await restoreInitialUprightPose();
                };

                const finishDrag = async () => {
                  const completedDrag = pointerMoved;
                  dragging = false;
                  pointerStart = null;
                  pointerMoved = false;
                  stopRotation();
                  if (completedDrag && config.lockXAxis) await scheduleXAxisRestore();
                  startRotation();
                };

                const reportCurrentRotation = () => {
                  if (!window.Pacdora || typeof window.Pacdora.get3DRotation !== 'function') {
                    notify('rotation:error');
                    return;
                  }

                  Promise.resolve(window.Pacdora.get3DRotation(viewerId))
                    .then((rotation) => {
                      if (!rotation) throw new Error('Rotation unavailable');
                      notify('rotation:current', {
                        x: normalizeAngle(rotationValue(rotation, 'x', 0)),
                        y: normalizeAngle(rotationValue(rotation, 'y', 1)),
                        z: normalizeAngle(rotationValue(rotation, 'z', 2))
                      });
                    })
                    .catch(() => notify('rotation:error'));
                };

                viewer.addEventListener('pointerenter', () => {
                  hovering = true;
                  startRotation();
                });

                viewer.addEventListener('pointerleave', () => {
                  hovering = false;
                  if (initialPoseReady) hoverRotationArmed = true;
                  stopRotation();
                });

                viewer.addEventListener('pointerdown', (event) => {
                  clearXAxisRestoreTimers();
                  dragging = true;
                  pointerMoved = false;
                  pointerStart = {
                    x: event.clientX,
                    y: event.clientY
                  };
                  stopRotation();
                });

                document.addEventListener('pointerdown', (event) => {
                  if (event.button !== 0) return;
                  clickStart = {
                    x: event.clientX,
                    y: event.clientY
                  };
                }, true);

                viewer.addEventListener('pointermove', (event) => {
                  if (!pointerStart) return;
                  const distance = Math.hypot(
                    event.clientX - pointerStart.x,
                    event.clientY - pointerStart.y
                  );
                  if (distance > 7) pointerMoved = true;
                });

                window.addEventListener('pointerup', finishDrag);
                window.addEventListener('pointercancel', finishDrag);
                window.addEventListener('blur', () => {
                  if (dragging) finishDrag();
                });

                document.addEventListener('pointerup', (event) => {
                  if (!clickStart) return;
                  const distance = Math.hypot(
                    event.clientX - clickStart.x,
                    event.clientY - clickStart.y
                  );
                  const shouldOpenAction = distance <= 6;
                  clickStart = null;
                  if (shouldOpenAction) toggleAction(event);
                }, true);

                window.addEventListener('message', (event) => {
                  const message = event.data || {};
                  if (message.source !== 'sky-pacdora-super-banner-parent') return;
                  if (message.sectionId !== config.sectionId || message.blockId !== config.blockId) return;

                  if (message.type === 'open-editor') {
                    if (!config.appKey) {
                      notify('editor:error');
                      return;
                    }
                    editorTrigger.click();
                  }

                  if (message.type === 'rotation:read') {
                    reportCurrentRotation();
                  }
                });

                const boot = async () => {
                  if (!window.Pacdora) throw new Error('Pacdora SDK unavailable');

                  await window.Pacdora.init({
                    appId: config.appId,
                    isDelay: true,
                    quotation: false,
                    customDefault: false,
                    theme: config.themeColor
                  });

                  window.Pacdora.$on('3d:init', async () => {
                    setTransparentBackground();
                    await enableNativeDragRotation();
                    if (typeof window.Pacdora.enable3DScale === 'function') {
                      await window.Pacdora.enable3DScale(viewerId, false);
                    }
                    if (typeof window.Pacdora.enable3DDrag === 'function') {
                      await window.Pacdora.enable3DDrag(viewerId, false);
                    }
                    await applyInitialPose();
                    notify('ready');
                  });

                  await window.Pacdora.createScene({
                    templateId: config.templateId,
                    isShowLoading: false,
                    doneBtn: 'Save'
                  });

                  setTransparentBackground();

                  await enableNativeDragRotation();
                  if (typeof window.Pacdora.enable3DScale === 'function') {
                    await window.Pacdora.enable3DScale(viewerId, false);
                  }
                  if (typeof window.Pacdora.enable3DDrag === 'function') {
                    await window.Pacdora.enable3DDrag(viewerId, false);
                  }

                  window.Pacdora.$on('advancedDesign:closed', () => notify('editor:closed'));
                  window.Pacdora.$on('design:cancel', () => notify('editor:closed'));
                  window.Pacdora.$on('design:save', () => notify('editor:saved'));

                  notify('ready');
                };

                boot().catch((error) => notify('error', error && error.message));
              })();
            </scr` + `ipt>
          </body>
        </html>`;
    };

    const findCard = (section, blockId) =>
      Array.from(section.querySelectorAll('[data-model-card]')).find(
        (card) => card.dataset.blockId === blockId
      );

    const initializeSection = (section) => {
      if (section.dataset.superBannerInitialized === 'true') return;
      section.dataset.superBannerInitialized = 'true';

      const configElement = section.querySelector('[data-super-banner-config]');
      if (!configElement) return;

      let config;
      try {
        config = JSON.parse(configElement.textContent);
      } catch (error) {
        return;
      }

      const uiLayer = section.querySelector('[data-model-ui-layer]');
      const modelsStage = section.querySelector('[data-models-stage]');
      const globalLoading = section.querySelector('[data-global-loading]');
      const globalLoadingLabel = section.querySelector('[data-global-loading-label]');
      const loadState = new Map(
        config.models
          .filter((model) => model.templateId)
          .map((model) => [model.blockId, 'deferred'])
      );

      const updateGlobalLoading = () => {
        if (!modelsStage || !globalLoading) return;
        const states = Array.from(loadState.values());
        if (!states.length) {
          globalLoading.hidden = true;
          modelsStage.classList.add('is-ready');
          return;
        }

        const readyCount = states.filter((state) => state === 'ready').length;
        const pending = states.some((state) => state === 'loading');
        if (pending && !readyCount) {
          globalLoading.hidden = false;
          globalLoading.style.opacity = '1';
          if (globalLoadingLabel) globalLoadingLabel.textContent = config.loadingLabel;
          return;
        }

        const errorCount = states.filter((state) => state === 'error').length;
        if (!readyCount && errorCount && globalLoadingLabel) {
          globalLoading.hidden = false;
          globalLoading.style.opacity = '1';
          globalLoadingLabel.textContent = config.errorLabel;
          return;
        }

        modelsStage.classList.add('is-ready');
        if (globalLoading.hidden) return;
        globalLoading.style.opacity = '0';
        window.setTimeout(() => {
          globalLoading.hidden = true;
        }, 220);
      };
      const getActionBubble = (card) => {
        if (!card) return null;
        const blockId = card.dataset.blockId;
        return section.querySelector(
          `[data-model-action-bubble][data-action-block-id="${CSS.escape(blockId)}"]`
        );
      };

      section.querySelectorAll('[data-model-action-bubble]').forEach((bubble) => {
        if (uiLayer) uiLayer.appendChild(bubble);
      });

      const rotationReaders = new Map();
      const normalizeSettingAngle = (value) => {
        const normalized = ((Number(value) % 360) + 360) % 360;
        return Math.abs(normalized) < 0.005 ? 0 : Number(normalized.toFixed(1));
      };

      const positionRotationReader = (card, reader) => {
        if (!card || !reader || !uiLayer) return;
        const layerRect = uiLayer.getBoundingClientRect();
        const stage = card.querySelector('[data-model-stage]');
        if (!stage) return;
        const stageRect = stage.getBoundingClientRect();
        const left = Math.max(
          12,
          Math.min(layerRect.width - Math.max(reader.offsetWidth, 180) - 12, stageRect.left - layerRect.left + 12)
        );
        const top = Math.max(
          12,
          Math.min(layerRect.height - Math.max(reader.offsetHeight, 76) - 12, stageRect.top - layerRect.top + 12)
        );
        reader.style.left = `${left}px`;
        reader.style.top = `${top}px`;
      };

      if (config.designMode && uiLayer) {
        config.models.forEach((model) => {
          const card = findCard(section, model.blockId);
          if (!card) return;
          const reader = document.createElement('div');
          reader.className = 'sky-super-banner__rotation-reader';
          reader.dataset.rotationReader = model.blockId;
          reader.innerHTML = `
            <button class="sky-super-banner__rotation-reader-button" type="button">读取当前角度</button>
            <span class="sky-super-banner__rotation-reader-output">拖拽模型到目标姿态后点击读取。</span>
          `;
          reader.querySelector('button').addEventListener('click', () => {
            const viewer = card._skySuperBannerViewer;
            const output = reader.querySelector('.sky-super-banner__rotation-reader-output');
            if (!viewer || !viewer.contentWindow) {
              output.textContent = '模型仍在加载，请稍后再试。';
              return;
            }
            output.textContent = '正在读取…';
            viewer.contentWindow.postMessage({
              source: 'sky-pacdora-super-banner-parent',
              sectionId: config.sectionId,
              blockId: model.blockId,
              type: 'rotation:read'
            }, '*');
          });
          uiLayer.appendChild(reader);
          rotationReaders.set(model.blockId, reader);
          window.requestAnimationFrame(() => positionRotationReader(card, reader));
        });
      }

      const positionModelAction = (card, bubble, detail = {}) => {
        if (!card || !bubble || !uiLayer) return;
        const layerRect = uiLayer.getBoundingClientRect();
        const stage = card.querySelector('[data-model-stage]');
        if (!stage) return;
        const stageRect = stage.getBoundingClientRect();

        let viewportX;
        let viewportY;
        if (typeof detail.x === 'number' && typeof detail.y === 'number') {
          viewportX = detail.x;
          viewportY = detail.y;
        } else {
          const styles = getComputedStyle(card);
          const xPercent = parseFloat(styles.getPropertyValue('--sky-super-banner-action-x')) || 42;
          const yPercent = parseFloat(styles.getPropertyValue('--sky-super-banner-action-y')) || 48;
          viewportX = stageRect.left + (stageRect.width * xPercent) / 100;
          viewportY = stageRect.top + (stageRect.height * yPercent) / 100;
        }

        const left = Math.max(
          12,
          Math.min(layerRect.width - Math.max(bubble.offsetWidth, 120) - 12, viewportX - layerRect.left)
        );
        const top = Math.max(
          12,
          Math.min(layerRect.height - Math.max(bubble.offsetHeight, 44) - 12, viewportY - layerRect.top)
        );
        bubble.style.left = `${left}px`;
        bubble.style.top = `${top}px`;
      };

      const closeModelActions = (exceptCard = null) => {
        section.querySelectorAll('[data-model-card]').forEach((card) => {
          if (card === exceptCard) return;
          const stage = card.querySelector('[data-model-stage]');
          const bubble = getActionBubble(card);
          if (stage) stage.setAttribute('aria-expanded', 'false');
          if (bubble) {
            bubble.hidden = true;
            bubble.style.setProperty('display', 'none', 'important');
          }
        });
      };

      const toggleModelAction = (card) => {
        const stage = card && card.querySelector('[data-model-stage]');
        const bubble = getActionBubble(card);
        if (!stage || !bubble) return;

        const willOpen = bubble.hidden;
        closeModelActions(card);
        if (willOpen) {
          bubble.hidden = false;
          bubble.style.setProperty('display', 'block', 'important');
          bubble.style.setProperty('z-index', '2147483646', 'important');
          positionModelAction(card, bubble);
        } else {
          bubble.hidden = true;
          bubble.style.setProperty('display', 'none', 'important');
        }
        stage.setAttribute('aria-expanded', String(willOpen));
      };

      const openModelAction = (card, detail = {}) => {
        const stage = card && card.querySelector('[data-model-stage]');
        const bubble = getActionBubble(card);
        if (!stage || !bubble) return;

        closeModelActions(card);
        bubble.hidden = false;
        bubble.style.setProperty('display', 'block', 'important');
        bubble.style.setProperty('z-index', '2147483646', 'important');
        positionModelAction(card, bubble, detail);
        stage.setAttribute('aria-expanded', 'true');
      };

      const repositionOpenActions = () => {
        section.querySelectorAll('[data-model-card]').forEach((card) => {
          const bubble = getActionBubble(card);
          if (bubble && !bubble.hidden) positionModelAction(card, bubble);
        });
        rotationReaders.forEach((reader, blockId) => {
          positionRotationReader(findCard(section, blockId), reader);
        });
      };
      window.addEventListener('resize', repositionOpenActions, { passive: true });

      document.addEventListener('pointerdown', (event) => {
        const actionBubble = event.target.closest('[data-model-action-bubble]');
        const modelCard = event.target.closest('[data-model-card]');
        if (!section.contains(event.target) || (!actionBubble && !modelCard)) {
          closeModelActions();
        }
      });

      const createModelFrame = (model) => {
        const card = findCard(section, model.blockId);
        const stage = card && card.querySelector('[data-model-stage]');
        if (!card || !stage || !model.templateId || !config.appId) return null;
        if (card._skySuperBannerViewer) return card._skySuperBannerViewer;

        loadState.set(model.blockId, 'loading');
        updateGlobalLoading();

        const viewer = document.createElement('iframe');
        viewer.className = 'sky-super-banner__viewer';
        viewer.title = model.label;
        viewer.loading = 'lazy';
        viewer.setAttribute(
          'sandbox',
          'allow-scripts allow-same-origin allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-downloads'
        );
        viewer.srcdoc = frameDocument(config, model);
        stage.appendChild(viewer);
        card._skySuperBannerViewer = viewer;

        return viewer;
      };

      config.models.forEach((model) => {
        const card = findCard(section, model.blockId);
        const stage = card && card.querySelector('[data-model-stage]');
        if (!card || !stage || !model.templateId) return;

        stage.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          if (event.target !== stage) return;
          event.preventDefault();
          toggleModelAction(card);
        });

        stage.addEventListener('click', (event) => {
          if (event.target.closest('[data-model-action-bubble]')) return;
          if (event.target.classList.contains('sky-super-banner__viewer')) return;
          toggleModelAction(card);
        });
      });

      window.addEventListener('message', (event) => {
        const message = event.data || {};
        if (message.source !== 'sky-pacdora-super-banner') return;
        if (message.sectionId !== config.sectionId) return;

        const card = findCard(section, message.blockId);
        if (!card) return;

        const viewer = card._skySuperBannerViewer;
        const stage = card.querySelector('[data-model-stage]');
        if (message.type === 'action:toggle') {
          toggleModelAction(card);
        }

        if (message.type === 'action:open') {
          openModelAction(card, message.detail || {});
        }

        if (message.type === 'rotation:current') {
          const reader = rotationReaders.get(message.blockId);
          const model = config.models.find((item) => item.blockId === message.blockId);
          if (reader && model && message.detail) {
            const output = reader.querySelector('.sky-super-banner__rotation-reader-output');
            const x = Number(message.detail.x) || 0;
            const displayedY = Number(message.detail.y) || 0;
            const y = normalizeSettingAngle(
              displayedY -
              (Number(model.rotationFineY) || 0)
            );
            const z = Number(message.detail.z) || 0;
            const text = `请填写：X ${x}°，Y ${y}°，Z ${z}°（Y 已扣除精细调整值）`;
            output.textContent = `${text}；已复制`;
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(text).catch(() => {});
            }
          }
        }

        if (message.type === 'rotation:error') {
          const reader = rotationReaders.get(message.blockId);
          const output = reader && reader.querySelector('.sky-super-banner__rotation-reader-output');
          if (output) output.textContent = '当前角度读取失败，请等待模型完全加载后重试。';
        }

        if (message.type === 'ready') {
          loadState.set(message.blockId, 'ready');
          card.classList.add('is-ready');
          updateGlobalLoading();
        }

        if (message.type === 'error') {
          loadState.set(message.blockId, 'error');
          updateGlobalLoading();
        }

        if (message.type === 'editor:closed' || message.type === 'editor:saved') {
          if (viewer) {
            viewer.classList.remove('is-editor-open');
            if (stage) stage.appendChild(viewer);
          }
        }

        if (message.type === 'editor:error') {
          if (viewer) {
            viewer.classList.remove('is-editor-open');
            if (stage) stage.appendChild(viewer);
          }
          if (globalLoading && globalLoadingLabel) {
            globalLoading.hidden = false;
            globalLoading.style.opacity = '1';
            globalLoadingLabel.textContent = config.editorErrorLabel;
          }
        }
      });

      const requestedPrimaryPosition = Number.parseInt(config.primaryModelPosition, 10) - 1;
      const primaryIndex = Math.min(
        Math.max(requestedPrimaryPosition, 0),
        Math.max(config.models.length - 1, 0)
      );
      let primaryModel = config.models[primaryIndex];
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const mobilePicker = section.querySelector('.sky-super-banner__mobile-picker');

      const activateModel = (model) => {
        if (!model) return;
        createModelFrame({
          ...model,
          autoRotate: Boolean(config.autoRotate && primaryModel && model.blockId === primaryModel.blockId)
        });
      };
      if (mobilePicker) {
        mobilePicker.addEventListener('click', (event) => {
          const button = event.target.closest('[data-mobile-model]');
          if (!button) return;
          const selected = config.models.find((model) => model.blockId === button.dataset.mobileModel);
          if (!selected || !selected.templateId) return;
          primaryModel = selected;
          section.querySelectorAll('[data-model-card]').forEach((card) => {
            card.dataset.primaryModel = String(card.dataset.blockId === selected.blockId);
          });
          mobilePicker.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          activateModel(selected);
        });
      }

      config.models.forEach((model) => {
        const card = findCard(section, model.blockId);
        const stage = card && card.querySelector('[data-model-stage]');
        if (!card || !stage || !model.templateId) return;

        const activateFromIntent = () => {
          const isPrimary = primaryModel && model.blockId === primaryModel.blockId;
          if (mobileQuery.matches && !isPrimary) return;
          activateModel(model);
        };

        stage.addEventListener('pointerenter', activateFromIntent, { once: true });
        stage.addEventListener('focusin', activateFromIntent, { once: true });
        stage.addEventListener('touchstart', activateFromIntent, { once: true, passive: true });
      });

      const activateVisibleModels = (event) => {
        if (event && event.detail && event.detail.allowHeavy === false) return;
        if (mobileQuery.matches) {
          activateModel(primaryModel);
          return;
        }
        config.models.forEach(activateModel);
      };

      section.addEventListener('sky:load', activateVisibleModels, { once: true });
      if (window.SkyProgressiveLoading) {
        window.SkyProgressiveLoading.register(section);
      }

      if (config.designMode) {
        config.models.forEach(activateModel);
      } else if (section.dataset.skyLoadState === 'active') {
        activateVisibleModels();
      }

      updateGlobalLoading();
      window.setTimeout(() => {
        loadState.forEach((state, blockId) => {
          if (state === 'loading') loadState.set(blockId, 'error');
        });
        updateGlobalLoading();
      }, 8000);
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll(selector).forEach(initializeSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
